import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Tooltip from 'flarum/common/components/Tooltip';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';

import getFlagEmojiUrl from 'flarum/fof/geoip/utils/getFlagEmojiUrl';

export default () => {
    country_icon();
}

function locale_to_country(locale)
{
    const defaults = {
        ru: 'ru',
        en: 'us', // gb
        zh: 'cn',
        es: 'es',
        hi: 'in',
        ar: 'ae'
    };

    return defaults[locale.substr(0, 2)];
}

function country_icon() {
    if ('fof-geoip' in flarum.extensions) {
        const locales = Object.fromEntries(Object.entries(app.data.locales).map(a => a.reverse()));
        extend(HeaderSecondary.prototype, 'items', function (items) {
            items.get('locale').children.forEach((item) => {
                // Create an instance of Intl.DisplayNames for displaying full languages names
                const displayNames = new Intl.DisplayNames(app.data.locales, { type: 'language' });
                 // Get the country code from children item
                const countryCode = locales[item.children];
                // Get the full country name using the country code
                const countryName = displayNames.of(countryCode) ?? countryCode;
                // Get the full country emoji url using the country code
                const url = getFlagEmojiUrl(locale_to_country(countryCode));
                item.children = (
                    <Tooltip text={countryName}>
                        <span className='locale-label'>
                            <img src={url} alt={countryName} height='16' loading='lazy' />
                            {item.children}
                        </span>
                    </Tooltip>
                );
            });
        });
    } else {
        extend(HeaderSecondary.prototype, 'items', function (items) {
            items.get('locale').children.forEach((item) => {
                item.children = (
                    <span className='locale-label'>
                        {item.children}
                    </span>
                );
            });
        });
    }
}
